import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { RequestType, KeyValues3, KeyValues5, LocalService, Paging, RequestInitialization, GeneralConfigType, StatusWithId, Wrappers10, BulkLogDetailsInitialization, BulkLogStatus, BulkLogDetail } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';
import { ExcelData, ExcelDownloadTemplateType } from './file-save.service';

@Injectable({
  providedIn: 'root'
})
export class RequestManagementService {
  private controllerName = service_controllers_methods.request.controller;
  private methods = service_controllers_methods.request.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public createRequest(requestTypeType: RequestType, data1: KeyValues5, data2: KeyValues5 = null): Observable<number> {
    let body = {
      sel: this.localService.getSelected(),
      rtype: requestTypeType,
      dt1: data1,
      dt2: data2
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.CreateRequest, body, false);
  }

  public createTestData(requestTypeType: RequestType): Observable<number> {
    let body = {
      sel: this.localService.getSelected(),
      rtype: requestTypeType
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.CreateTestData, body, false);
  }

  public getRequestInitialization(parentId: string): Observable<RequestInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      selD: { v3: parentId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetRequestInitialization, body);
  }

  public getRequests(paging: Paging, selectedData: KeyValues3): Observable<Wrappers10> {
    if (paging == null)
      paging = this.localService.getLastPagingSetup(GeneralConfigType.PagingRequests);

    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      selD: selectedData
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetRequests, body, paging != null && !paging.isAutoRefresh);
  }

  public checkContentLength(body: any, isRawJson: boolean): Observable<any> {
    return this.httpService.request_general_post(this.controllerName + this.methods.CheckContentLength, body, true, isRawJson);
  }

  public retryJob(requestId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: requestId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.RetryJob, body, true, false, true);
  }

  public downloadExcelTemplate(excelDownloadTemplateType: ExcelDownloadTemplateType, key?: string): Observable<ExcelData[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: excelDownloadTemplateType.toString(), v1: key } as KeyValues3
    };
    return this.httpService.request_general_post_blob_response(this.controllerName + this.methods.DownloadExcelTemplate, body, true, true);
  }

  public getBulkLogDetailsInitialization(logId: string, ctryCode = ''): Observable<BulkLogDetailsInitialization> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { key: logId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBulkLogDetailsInitialization, body);
  }

  public getBulkLogDetails(logId: string, iRow: number, productLogStatus: BulkLogStatus, ctryCode = ''): Observable<BulkLogDetail> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { key: logId, v1: iRow.toString(), v2: productLogStatus.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBulkLogDetails, body);
  }
}
